module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAPFJREFUSA1jYCAS/G9XDf7frvz0f7tKFpFawMqYiFf8L4nh/38pIM4kXg8DAwkW/GeBGAyjibOGBAuIMxBd1agF6CGCwR8NIowgQRdg/N+pFMTwjzGZgYFQ+mY0BmYyYQZGhq9AQ46iG4TC/8/4H5jD1jJW3J3NCMr+4ByKooIKHEbG3wwVd9iBuZOxFWgcMPsT8gGDHFAdF1D9L6Dae3idwAj0wX/G1YxAmhGvQiTJ/+1KOxn+M7gBhW4wVt3TRJLCyxxNpniDByQ5GkRDKYhA2R8EQJmIBEB8JDMyrAMa/huUQ0kwnzSl//8Tn/NhJgMA8Cg6pExUfHEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/btn_add.png
// module id = +MlM
// module chunks = 0